<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/process/manage_harvested_batch/list_harvested_batches.yml"
  lang="yaml"
></i18n>

<template>

  <div>
    <go-back-link :text="$t('labels.go_back_link')" name="ph_process_harvested_batches_show_process_path" :params="{
      packing_house_process_id: this.packing_house_process_id,
      packing_house_id: this.packing_house_id,
    }" />
    <bread-crumbs :labels="[
      module_name,
      packing_house_process.name,
      $t('labels.harvested_batches_title'),
    ]"></bread-crumbs>

    <div class="flex flex-row justify-end">
      <div class="panel-plain-label">
        <badge-default :label="harvested_batches.length+' '+$t('labels.total_harvested_batches')" />
      </div>
      <div class="grow">

      </div>
      <new-button @click.prevent="goToNewHarvestedBatch" :label="$t('labels.new_harvested_batch_button')" />
    </div>

    <ag-grid-vue v-if="render_list" style="height: 500px" class="ag-theme-alpine w-full h-full" :columnDefs="columnDefs"
      :defaultColDef="defaultColDef" :rowData="harvested_batches">
    </ag-grid-vue>
    <loading-message v-else />

    <div class="mt-8 flex flex-col" v-if="render_list">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.batch_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.harvested_packages") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.total_weight") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.discarded_weight") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.ok_weight") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.registered_at") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.crop") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.producer") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.crop_type") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.harvested_batch.crop_variety") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr class="table-row" v-for="harvested_batch in harvested_batches" :key="harvested_batch.id">
                  <td class="table-cell-main cursor-pointer" @click.prevent="
                    goToShowHarvestedBatch(harvested_batch.id)
                  ">
                    {{ harvested_batch.batch_code }}
                  </td>
                  <td class="table-cell">
                    <ul>
                      <li v-for="(
                            harvested_package, idx
                          ) in harvested_batch.harvested_packages" :key="idx">
                        {{ harvested_package.number }}
                        {{ harvested_package.crop_har_package.name }}
                      </li>
                    </ul>
                  </td>
                  <td class="table-cell">
                    {{ numberWithPrecision(harvested_batch.total_weight) }}
                  </td>
                  <td class="table-cell">
                    {{
                    numberWithPrecision(harvested_batch.discarded_weight)
                    }}
                  </td>
                  <td class="table-cell">
                    {{ numberWithPrecision(harvested_batch.ok_weight) }}
                  </td>
                  <td class="table-cell">
                    {{ dateFormatter(harvested_batch.registered_at) }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_batch.crop.name }}
                  </td>
                  <td class="table-cell">
                    {{ producerLabel(harvested_batch) }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_batch.crop_type.name }}
                  </td>
                  <td class="table-cell">
                    {{ harvested_batch.crop_variety.name }}
                  </td>
                  <td class="table-cell-action">
                    <a class="link flex" @click.prevent="
                      goToShowHarvestedBatch(harvested_batch.id)
                    ">
                      <i class="fa-solid fa-pen"></i>
                      <span class="space-icon"></span>{{ $t("labels.manage_link") }}
                    </a>
                    <manage-batch-link />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <loading-message v-else />
    
  </div>
</template>

<script>

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue3";


import Requester from "@/views/packing_house/requesters/process/harvested_batches/manage_harvested_batch.js";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";

import ManageBatchLink from "@/components/views/packing_house/process/harvested_batches/ManageBatchLink.js"

export default {
  name: "ListHarvestedBatches",
  components: {
    BreadCrumbs,
    AgGridVue,
    ManageBatchLink,
  },
  data() {
    return {
      packing_house_process: {},
      harvested_batches: [],
      render_list: false,
      defaultColDef: {
        sortable: true,
        filter: true,
        floatingFilter: true,
      },
      columnDefs: [
        { headerName: this.$t("model.harvested_batch.batch_code"), field: "batch_code", filter: true },
        { headerName: this.$t("model.harvested_batch.harvested_packages"), field: "f_harvested_packages", floatingFilter: true },
        { headerName: this.$t("model.harvested_batch.total_weight"), field: "f_total_weight" },
        { headerName: this.$t("model.harvested_batch.discarded_weight"), field: "f_discarded_weight" },
        { headerName: this.$t("model.harvested_batch.ok_weight"), field: "f_ok_weight" },
        { headerName: this.$t("model.harvested_batch.registered_at"), field: "f_registered_at", filter: 'agDateColumnFilter', },
        { headerName: this.$t("model.harvested_batch.producer"), field: "producer.name" },
        { headerName: this.$t("model.harvested_batch.crop_type"), field: "crop_type.name" },
        { headerName: this.$t("model.harvested_batch.crop_variety"), field: "crop_variety.name" },
        {
          headerName: '',

          //cellRendererSelector: (params) => {
            //console.log("params")
            //console.log(params.data);
          //  return {
          //    component: 'ManageBatchLink',
          //    params: params.data,
          //  };
          //}

        },




      ],
    };
  },
  props: {
    packing_house_process_id: {
      required: true,
    },
    packing_house_id: {
      required: true,
    },
  },
  created() {
    this.checkIfAuthenticated().then(() => {
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.fetchPackingHouseProcess();
        this.fetchHarvestedBatches();
      });
    });
  },
  methods: {
    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess(
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },
    fetchHarvestedBatches: async function () {
      let response = await Requester.fetchHarvestedBatches(
        this.packing_house_process_id
      );

      this.harvested_batches = response.data;

      for (let i = 0; i < this.harvested_batches.length; i++) {

        let packages = '';

        this.harvested_batches[i].harvested_packages.forEach((p) => {
          packages += p.number + ' ' + p.crop_har_package.name
        });

        this.harvested_batches[i].f_harvested_packages = packages;
        this.harvested_batches[i].f_total_weight = this.numberWithPrecision(this.harvested_batches[i].total_weight);
        this.harvested_batches[i].f_discarded_weight = this.numberWithPrecision(this.harvested_batches[i].discarded_weight);
        this.harvested_batches[i].f_ok_weight = this.numberWithPrecision(this.harvested_batches[i].ok_weight);
        this.harvested_batches[i].f_registered_at = this.dateFormatter(this.harvested_batches[i].registered_at)
      }

      this.render_list = true;
    },
    producerLabel: function (harvested_batch) {
      if (harvested_batch.producer && harvested_batch.organization) {
        return `${harvested_batch.producer.name} (${harvested_batch.organization.name})`;
      } else if (harvested_batch.organization) {
        return harvested_batch.organization.name;
      } else if (harvested_batch.producer) {
        return harvested_batch.producer.name;
      }
    },
    goToShowHarvestedBatch: function (harvested_batch_id) {
      this.$router.push({
        name: "ph_process_harvested_batches_show",
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          harvested_batch_id: harvested_batch_id,
        },
      });
    },
    goToNewHarvestedBatch: function () {
      this.$router.push({
        name: "ph_process_harvested_batches_new",
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
        },
      });
    },
  },
};
</script>
